<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :search.sync="searchForm"
               :page="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">

      <template slot="feeTaxTypeIdForm" slot-scope="scope">
        <el-select
          v-model="form.feeTaxTypeId"
          placeholder="请选择商品名称"
          style="width: 100%"
          @change="(value)=>feeTaxTypeIdChange(value)"
        >
          <el-option
            v-for="item in feeTaxList"
            :key="item.id"
            :label="item.concatName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="feeSortsForm" slot-scope="scope">
        <el-select
          v-model="form._feeSorts"
          placeholder="请选择费用种类"
          multiple
          clearable
          collapse-tags
          style="width: 100%"
          @change="(value)=>feeSortChange(value)"
        >
          <el-option
            v-for="item in feeSortList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>

      <template slot="taxFeeSortSearch" slot-scope="scope">
        <el-input
          style="width:100%"
          clearable
          v-model="query.searchTaxFeeSort"
          placeholder="收费项目名称"
        >
        </el-input>
      </template>

      <template slot="normalRateLabel" slot-scope="scope">
        <span>一般纳税人税率:</span>
      </template>

      <template slot="smallRateLabel" slot-scope="scope">
        <span>小规模纳税人税率:</span>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" v-if="permissionList.editBtn" @click="$refs.crud.rowEdit(scope.row)">编辑 </el-button>
        <el-button type="text" size="small" v-if="permissionList.delBtn" @click="$refs.crud.rowDel(scope.row)">删除 </el-button>
        <el-button type="text" size="small" v-if="permissionList.logBtn" @click="openOperateLogDialog(scope.row)">日志
        </el-button>
      </template>

    </avue-crud>

    <FeeItemTaxLog v-if="operateLogVisible" :visible.sync="operateLogVisible" :feeTaxItemId="feeTaxItemId"></FeeItemTaxLog>
  </basic-container>
</template>

<script>
import {
  getPage,
  add,
  update,
  remove,
  getDetail,
  getSortTypeList,
  getPayTypeList,
  getCommunityList
} from "@/api/v4ward/digitaltickets/feeitemtax/FeeItemTax.js";
import { getList } from "@/api/v4ward/digitaltickets/feetaxtype/FeeTaxType.js";
import {mapGetters} from "vuex";
import { getFeeTypes } from '../../offlinepay/index.js';
import { getDictionary } from '@/api/common.js';
import FeeItemTaxLog from './FeeItemTaxLog.vue';

export default {
  components: { FeeItemTaxLog },
  data() {
    return {
      feeTaxItemId:'',
      operateLogVisible:false,
      feeSortList:[],
      deptNameFlag:false,
      projectList:[],
      deptList:[],
      form: {
        id : '',
        feeTaxTypeId : '',
        normalRate : '0',
        smallRate : '0',
        model : 'UN_USE',
        number : 'UN_USE',
        discountPolicy : 'UN_USE',
        taxFlag : 'YES',
        feeSorts:'',
      },
      query: {
        searchTaxFeeSort:'',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      tempFeeTax: '',
      option: {
        labelWidth: 140,
        menuWidth: 140,
        // indexLabel:"序号",
        menu: true,
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        addBtn: true,
        delBtn: false,
        editBtn: false,
        // searchBtn: false,
        // emptyBtn: false,
        searchMenuSpan: 18,
        border: true,
        // index: true,
        viewBtn: false,
        dialogClickModal: false,
        column: [
          {
            label: "收费项目名称",
            prop: "taxFeeSort",
            editDisabled: true,
            searchslot:true,
            search:true,
            searchLabelWidth: 100,
            order: 17,
            width: 100,
            searchSpan: 6,
            type: "select",
            dicData:[],
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [{
              required: true,
              message: "请选择收费项目",
              trigger: "change"
            }]
          },
          {
            label: "商品名称",
            prop: "feeTaxTypeId",
            order: 16,
            hide: true,
            showColumn:false,
            formslot: true,
            rules: [{
              required: true,
              message: "请选择商品名称",
              trigger: "change"
            }]
          },
          {
            label: "商品名称",
            prop: "feeTaxFullName",
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "商品编码",
            prop: "feeTaxCode",
            order: 15,
            disabled:true,
            rules: [{
              required: true,
              message: "请选择商品编码",
              trigger: "change"
            }]
          },
          {
            label: "商品简码",
            prop: "feeTaxName",
            order: 14,
            disabled:true,
            rules: [{
              required: true,
              message: "请选择商品简码",
              trigger: "change"
            }]
          },
          {
            label: "一般纳税人税率(%)",
            prop: "normalRate",
            clearable:false,
            width: 130,
            labelslot: true,
            type: 'select',
            dataType:'string',
            placeholder:"请选择一般纳税人税率",
            dicData:[],
            order: 13,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            formatter: (row) => {
              return row.normalRate + '%';
            },
            rules: [
              {
                pattern:/^\d*?$/,
                message: '格式错误',
              },
              {
                required: true,
                message: "请选择一般纳税人税率",
                trigger: "change"
              }
            ],
          },
          {
            label: "小规模纳税人税率(%)",
            prop: "smallRate",
            clearable:false,
            order: 12,
            type: 'select',
            width: 140,
            labelslot: true,
            placeholder:"请选择小规模纳税人税率",
            dicData:[],
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              {
                pattern:/^\d*?$/,
                message: '格式错误',
              },
              {
                required: true,
                message: "请选择小规模纳税人税率",
                trigger: "change"
              }
            ],
            formatter: (row) => {
              return row.smallRate + '%';
            }
          },
          {
            label: "关联小区",
            prop: "communityNames",
            width: 200,
            overHidden: true,
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "费用种类",
            prop: "feeSortNames",
            overHidden: true,
            width: 100,
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "种类细分",
            prop: "sortTypeNames",
            overHidden: true,
            width: 100,
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "种类细分",
            prop: "sortTypes",
            overHidden: true,
            type: 'select',
            multiple:true,
            hide: true,
            showColumn: false,
            tags:true,
            order: 2,
            dicData:[],
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            label: "面缴费用类型",
            prop: "facePayFeeTypes",
            hide: true,
            type: 'select',
            width: 100,
            order: 4,
            multiple:true,
            tags:true,
            dicData:[],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: "面缴费用类型",
            prop: "facePayFeeTypeNames",
            overHidden: true,
            width: 100,
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "关联支付方式",
            prop: "payTypeNames",
            overHidden: true,
            width: 100,
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "关联支付方式",
            prop: "payTypes",
            showColumn: false,
            overHidden: true,
            type: 'select',
            width: 100,
            order: 1,
            multiple:true,
            hide: true,
            tags:true,
            dicData:[],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: "是否支持C端开票",
            prop: "supportClientInvoice",
            clearable:false,
            width: 120,
            order: 6,
            type: 'select',
            dicData:[
              {label:'是',value: 'YES'},
              {label:'否',value: 'NO'},
            ],
            rules: [
              {
                required: true,
                message: "请选择是否支持C端开票",
                trigger: "change"
              }
            ],
          },
          {
            label: "规格型号",
            prop: "model",
            clearable:false,
            type: 'select',
            dicData:[],
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            order: 11,
          },
          {
            label: "计量单位",
            prop: "unit",
            maxlength: 20,
            showWordLimit:true,
            order: 10,
          },
          {
            label: "数量",
            prop: "number",
            clearable:false,
            type: 'select',
            order: 9,
            dicData:[],
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            label: "优惠政策",
            prop: "discountPolicy",
            clearable:false,
            type: 'select',
            order: 8,
            dicData:[],
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            label: "含税标志",
            prop: "taxFlag",
            clearable:false,
            type: 'select',
            order: 7,
            dicData:[],
            props: {
              label: "dictValue",
              value: "dictKey",
            },
          },
          {
            label: "关联小区",
            prop: "communityIds",
            type: 'tree',
            hide: true,
            showColumn: false,
            multiple:true,
            filterable:true,
            order: 5,
            overHidden: true,
            props: {
              label: 'communityName',
              value: 'communityId',
            },
            dicData:[{
              communityName:'一部',
              communityId: 1,
              children:[]
            },{
              communityName:'二部',
              communityId: 2,
              children:[]
            }]
          },
          {
            label: "费用种类",
            prop: "feeSorts",
            type: 'select',
            hide: true,
            showColumn: false,
            order: 3,
            dicData:[],
            tags:true,
            formslot: true,
          },
        ]
      },
      data: [],
      searchForm:{

      },
      feeTaxList: [],
    };
  },
  watch: {
  },
  mounted(){
    this.adjustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  created(){
    this.initFeeTaxList();
    this.initCommunityIds();
    this.initOffLineFeeType();
    getDictionary('fee_sort').then((res) => {
      this.feeSortList = res.data;
    });
    getDictionary('fee_tax_discount_policy').then((res) => {
      this.findObject(this.option.column,'discountPolicy').dicData = res.data;
    });
    getDictionary('yes_or_no').then((res) => {
      this.findObject(this.option.column,'taxFlag').dicData = res.data;
    });
    getDictionary('fee_tax_number').then((res) => {
      this.findObject(this.option.column,'number').dicData = res.data;
    });
    getDictionary('fee_tax_model').then((res) => {
      this.findObject(this.option.column,'model').dicData = res.data;
    });
    getDictionary('fee_tax_rate').then((res) => {
      this.findObject(this.option.column,'smallRate').dicData = res.data;
      this.findObject(this.option.column,'normalRate').dicData = res.data;
    });
    getDictionary('tax_fee_sort').then((res) => {
      this.findObject(this.option.column,'taxFeeSort').dicData = res.data;
    });
    getPayTypeList().then((res) => {
      this.findObject(this.option.column,'payTypes').dicData = res.data;
    });
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.feeitemtax_add, false),
        delBtn: this.vaildData(this.permission.feeitemtax_delete, false),
        editBtn: this.vaildData(this.permission.feeitemtax_edit, false),
        logBtn: this.vaildData(this.permission.feeitemtax_log, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  methods: {
    openOperateLogDialog(row){
      this.feeTaxItemId = row.id;
      this.operateLogVisible = true;
    },
    feeSortChange(value){
      this.form.sortTypes = '';
      getSortTypeList({feeSortKeys:value.join(",")}).then((res) => {
        this.findObject(this.option.column,'sortTypes').dicData = res.data;
      });
    },
    adjustView() {
      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    feeTaxTypeIdChange(value){
      this.tempFeeTax = '';
      this.form.feeTaxCode = '';
      this.form.feeTaxName = '';
      this.tempFeeTax = this.feeTaxList.find(item => item.id == value);
      if(this.tempFeeTax){
        this.form.feeTaxCode = this.tempFeeTax.taxCode;
        this.form.feeTaxName = this.tempFeeTax.taxName;
      }
    },
    initFeeTaxList() {
      getList().then((res) => {
        this.feeTaxList = res.data;
      }, error => {
        window.console.log(error);
      });
    },
    initCommunityIds(){
      getCommunityList({communityGroup:1}).then((res) => {
        if(res.data){
          this.findObject(this.option.column,'communityIds').dicData[0].children = res.data.filter(ele => ele.communityId != '-1');
        }
      });

      getCommunityList({communityGroup:2}).then((res) => {
        if(res.data){
          this.findObject(this.option.column,'communityIds').dicData[1].children = res.data.filter(ele => ele.communityId != '-1');
        }
      });
    },
    initOffLineFeeType(){
      getFeeTypes().then((res) => {
        this.findObject(this.option.column,'facePayFeeTypes').dicData = res.data;
      });
    },
    handleRow(row){
      if(row.communityIds && Array.isArray(row.communityIds)){
        row.communityIds = row.communityIds.join(",");
      }
      if(row._feeSorts && Array.isArray(row._feeSorts)){
        row.feeSorts = row._feeSorts.join(",");
      }
      if(row.payTypes && Array.isArray(row.payTypes)){
        row.payTypes = row.payTypes.join(",");
      }
      if(row.sortTypes && Array.isArray(row.sortTypes)){
        row.sortTypes = row.sortTypes.join(",");
      }
      if(row.facePayFeeTypes && Array.isArray(row.facePayFeeTypes)){
        row.facePayFeeTypes = row.facePayFeeTypes.join(",");
      }
    },
    rowSave(row, done, loading) {
      this.handleRow(row);
      add(row).then(() => {
        this.onLoad();
        this.$message.success('操作成功!');
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate(row, index, done, loading) {
      this.handleRow(row);
      update(row).then(() => {
        this.onLoad();
        this.$message.success('操作成功!');
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove({ids: row.id});
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove({ids: this.ids});
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      this.form.feeSorts = '';
      if (["edit"].includes(type)) {
        getDetail({id:this.form.id}).then(({data}) => {
          this.form = data;
          this.form.feeTaxTypeId = data.feeTaxTypeId;
          if(data.feeSorts){
            this.form._feeSorts = data.feeSorts.split(',');
          }
          getSortTypeList({feeSortKeys:data.feeSorts}).then((res) => {
            this.findObject(this.option.column,'sortTypes').dicData = res.data;
          });
          //关联小区
          if(data.communityIds){
            this.form.communityIds = data.communityIds.split(',').filter(ele => ele != '1' && ele != '2');
            console.log('this.form.communityIds》》', this.form.communityIds);
          }
          //面缴费用类型
          if(data.facePayFeeTypes){
            this.form.facePayFeeTypes = data.facePayFeeTypes.split(',');
          }
          //费用种类
          if(data.feeSorts){
            this.form.feeSorts = data.feeSorts.split(',');
          }
          //种类细分
          if(data.sortTypes){
            this.form.sortTypes = data.sortTypes.split(',');
          }
          //支付方式
          if(data.payTypes){
            this.form.payTypes = data.payTypes.split(',');
          }
        });
      }
      if (["add"].includes(type)) {
        this.form = {
          id : '',
          feeTaxTypeId : '',
          normalRate : '0',
          smallRate : '0',
          model : 'UN_USE',
          number : 'UN_USE',
          discountPolicy : 'UN_USE',
          taxFlag : 'YES',
          feeSorts:'',
          facePayFeeTypes:'',
          communityIds:'',
          sortTypes:'',
          payTypes:'',
        };
      }
      done();
    },
    searchReset() {
      setTimeout(()=>{
        this.query.searchTaxFeeSort = '';
        this.onLoad();
      },0)
    },
    searchChange(params, done) {
      this.query.taxCode = params.taxCode
      this.query.taxFullName = params.taxFullName
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getPage(
        Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
      ).then(({data}) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    }
  }
};
</script>

<!--最大化-->
<style lang="scss" scoped>
::v-deep .el-form-item {
  width: 100%;
}
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}
</style>
